import React 			from 'react';
import ReactDOM 		from 'react-dom';
import moment 			from 'moment';

import BLComponent		from '../../core/_BLComponent.jsx';

import CrowdNavigation 	from '../common/_CrowdNavigation.jsx';
import SeriesInternalNav from '../common/_SeriesInternalNav.jsx';
import BDPQuickViewModal from '../common/_BDPQuickViewModal.jsx';

import CrowdSubmissionResults from './_CrowdSubmissionResults.jsx';

import TimelineContent from './_TimelineContent.jsx';
import BDPHeader from '../common/_BDPHeader.jsx';

export default class CrowdSeriesValidation extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			showQuickView: false,
			quickViewStartId: null,
			seriesSubmissions: null
		};

		this.series 				= blapp.models.get('listSeries') || [];
		this.seriesNumber 	= parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.seriesContent 	= this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)];
	}

	render() {
		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={1}/> : null}
				{this.state.showQuickView ? <BDPQuickViewModal submissions={this.state.seriesSubmissions} activeSubmission={this.state.quickViewStartId} closeFunc={() => this.toggleQuickView(null)}/> : null}
				<BDPHeader series/>
				<SeriesInternalNav classes="bdp-series-main__series-nav-landing"/>
				<div className="main">
					<div className="main__content">
						{this.renderIntroBlock()}
						<CrowdSubmissionResults quickViewFunc={(id, mocs) => this.toggleQuickView(id, mocs)}/>
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderIntroBlock() {
		return (
			<article className="bdp-series-main__intro-block l-block">
				<div className="bdp-series-main__intro-block-content bdp-series-main__intro-block-content--validation text--center">
					<h1 className="bdp-series-main__intro-title">Vote for your favorite fan designs!</h1>
					<p className="text-color--darkestBlue bdp-series-main__intro-text">Use emoji to vote for as many designs as you wish until <strong>{moment(this.seriesContent.udtCrowdValidationEnd).format("MMMM Do")} at noon Pacific</strong>. Vote tallies are secret.</p>
					<article className="bdp-series-submissions__header-vote-tip">
						<p className="bdp-series-submissions__header-vote-tip-text">Choose one of these 3 options:</p>
						<div className="bdp-series-submissions__header-vote-tip-icons">
							<div className="bdp-series-submissions__header-vote-tip-item">
								<img className="bdp-series-submissions__header-vote-tip-item-image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-1.png`}/>
								<strong>Not for me</strong>
							</div>
							<div className="bdp-series-submissions__header-vote-tip-item">
								<img className="bdp-series-submissions__header-vote-tip-item-image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-2.png`}/>
								<strong>Like it</strong>
							</div>
							<div className="bdp-series-submissions__header-vote-tip-item">
								<img className="bdp-series-submissions__header-vote-tip-item-image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-3.png`}/>
								<strong>Love it</strong>
							</div>
						</div>
					</article>
				</div>
				<div className="bdp-series-timeline__container">
					<TimelineContent type="validation"/>
				</div>
			</article>
		);
	}

	toggleQuickView(id, mocs) {
		this.setState({showQuickView: !this.state.showQuickView, quickViewStartId: this.state.quickViewStartId ? null : id, seriesSubmissions: mocs});
		blapp.screen.toggleScroll(!this.state.showQuickView);
	}
};